/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  ITradeManagerOrders,
  ITradeManagerOrdersInterface,
} from "../ITradeManagerOrders";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IController",
        name: "controller_",
        type: "address",
      },
      {
        internalType: "contract IUserManager",
        name: "userManager_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "str",
        type: "string",
      },
    ],
    name: "StringTooLong",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "AddedMarginToPositionViaSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "ClosedPositionViaSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "EIP712DomainChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "ExtendedPositionToLeverageViaSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "ExtendedPositionViaSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addedMargin",
        type: "uint256",
      },
    ],
    name: "MarginAddedToPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "removedMargin",
        type: "uint256",
      },
    ],
    name: "MarginRemovedFromPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "OpenedPositionViaSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "collateral",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderReward",
        type: "uint256",
      },
    ],
    name: "OrderRewardTransfered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "PartiallyClosedPositionViaSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "PositionClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addedMargin",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addedLeverage",
        type: "uint256",
      },
    ],
    name: "PositionExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "targetLeverage",
        type: "uint256",
      },
    ],
    name: "PositionExtendedToLeverage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "PositionLiquidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "PositionOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proportion",
        type: "uint256",
      },
    ],
    name: "PositionPartiallyClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "RemovedMarginFromPositionViaSignature",
    type: "event",
  },
  {
    inputs: [],
    name: "ADD_MARGIN_TO_POSITION_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ADD_MARGIN_TO_POSITION_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CLOSE_POSITION_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CLOSE_POSITION_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CONSTRAINTS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXTEND_POSITION_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXTEND_POSITION_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXTEND_POSITION_TO_LEVERAGE_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXTEND_POSITION_TO_LEVERAGE_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPEN_POSITION_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPEN_POSITION_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PARTIALLY_CLOSE_POSITION_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PARTIALLY_CLOSE_POSITION_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REMOVE_MARGIN_FROM_POSITION_ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REMOVE_MARGIN_FROM_POSITION_PARAMS_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "addedMargin",
                type: "uint256",
              },
            ],
            internalType: "struct AddMarginToPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct AddMarginToPositionOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "addMarginToPositionViaSignature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tradePairs",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "positionIds",
        type: "uint256[][]",
      },
      {
        internalType: "bool",
        name: "allowRevert",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
    ],
    name: "batchLiquidatePositions",
    outputs: [
      {
        internalType: "bool[][]",
        name: "didLiquidate",
        type: "bool[][]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tradePairs_",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "positionIds_",
        type: "uint256[][]",
      },
    ],
    name: "canLiquidatePositions",
    outputs: [
      {
        internalType: "bool[][]",
        name: "canLiquidate",
        type: "bool[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tradePairs_",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "positionIds_",
        type: "uint256[][]",
      },
      {
        internalType: "int256[]",
        name: "prices_",
        type: "int256[]",
      },
    ],
    name: "canLiquidatePositionsAtPrices",
    outputs: [
      {
        internalType: "bool[][]",
        name: "canLiquidate",
        type: "bool[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
            ],
            internalType: "struct ClosePositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct ClosePositionOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "closePositionViaSignature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "controller",
    outputs: [
      {
        internalType: "contract IController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "detailsOfPosition",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "margin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "volume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "assetAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isShort",
            type: "bool",
          },
          {
            internalType: "int256",
            name: "entryPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "liquidationPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "currentBorrowFeeAmount",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "currentFundingFeeAmount",
            type: "int256",
          },
        ],
        internalType: "struct PositionDetails",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      {
        internalType: "bytes1",
        name: "fields",
        type: "bytes1",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "version",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "chainId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "verifyingContract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        internalType: "uint256[]",
        name: "extensions",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "targetLeverage",
                type: "uint256",
              },
            ],
            internalType: "struct ExtendPositionToLeverageParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionToLeverageOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "extendPositionToLeverageViaSignature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "addedMargin",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "addedLeverage",
                type: "uint256",
              },
            ],
            internalType: "struct ExtendPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "extendPositionViaSignature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair_",
        type: "address",
      },
    ],
    name: "getCurrentFundingFeeRates",
    outputs: [
      {
        internalType: "int256",
        name: "longFundingFeeRate",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "shortFundingFeeRate",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
        ],
        internalType: "struct ClosePositionParams",
        name: "closePositionParams",
        type: "tuple",
      },
    ],
    name: "hash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
            ],
            internalType: "struct ClosePositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct ClosePositionOrder",
        name: "closePositionOrder",
        type: "tuple",
      },
    ],
    name: "hash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "margin",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "leverage",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "isShort",
                type: "bool",
              },
              {
                internalType: "address",
                name: "referrer",
                type: "address",
              },
              {
                internalType: "address",
                name: "whitelabelAddress",
                type: "address",
              },
            ],
            internalType: "struct OpenPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct OpenPositionOrder",
        name: "openPositionOrder",
        type: "tuple",
      },
    ],
    name: "hash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "addedMargin",
                type: "uint256",
              },
            ],
            internalType: "struct AddMarginToPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct AddMarginToPositionOrder",
        name: "addMarginToPositionOrder",
        type: "tuple",
      },
    ],
    name: "hashAddMarginToPositionOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "addedMargin",
            type: "uint256",
          },
        ],
        internalType: "struct AddMarginToPositionParams",
        name: "addMarginToPositionParams",
        type: "tuple",
      },
    ],
    name: "hashAddMarginToPositionParams",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "addedMargin",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "addedLeverage",
                type: "uint256",
              },
            ],
            internalType: "struct ExtendPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionOrder",
        name: "extendPositionOrder",
        type: "tuple",
      },
    ],
    name: "hashExtendPositionOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "addedMargin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "addedLeverage",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionParams",
        name: "extendPositionParams",
        type: "tuple",
      },
    ],
    name: "hashExtendPositionParams",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "targetLeverage",
                type: "uint256",
              },
            ],
            internalType: "struct ExtendPositionToLeverageParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionToLeverageOrder",
        name: "extendPositionToLeverageOrder",
        type: "tuple",
      },
    ],
    name: "hashExtendPositionToLeverageOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "targetLeverage",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionToLeverageParams",
        name: "extendPositionToLeverageParams",
        type: "tuple",
      },
    ],
    name: "hashExtendPositionToLeverageParams",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "proportion",
                type: "uint256",
              },
            ],
            internalType: "struct PartiallyClosePositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct PartiallyClosePositionOrder",
        name: "partiallyClosePositionOrder",
        type: "tuple",
      },
    ],
    name: "hashPartiallyClosePositionOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "proportion",
            type: "uint256",
          },
        ],
        internalType: "struct PartiallyClosePositionParams",
        name: "partiallyClosePositionParams",
        type: "tuple",
      },
    ],
    name: "hashPartiallyClosePositionParams",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "removedMargin",
                type: "uint256",
              },
            ],
            internalType: "struct RemoveMarginFromPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct RemoveMarginFromPositionOrder",
        name: "removeMarginFromPositionOrder",
        type: "tuple",
      },
    ],
    name: "hashRemoveMarginFromPositionOrder",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "removedMargin",
            type: "uint256",
          },
        ],
        internalType: "struct RemoveMarginFromPositionParams",
        name: "removeMarginFromPositionParams",
        type: "tuple",
      },
    ],
    name: "hashRemoveMarginFromPositionParams",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "isProcessedSignature",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
    ],
    name: "liquidatePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "margin",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "leverage",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "isShort",
                type: "bool",
              },
              {
                internalType: "address",
                name: "referrer",
                type: "address",
              },
              {
                internalType: "address",
                name: "whitelabelAddress",
                type: "address",
              },
            ],
            internalType: "struct OpenPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct OpenPositionOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "openPositionViaSignature",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "proportion",
                type: "uint256",
              },
            ],
            internalType: "struct PartiallyClosePositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct PartiallyClosePositionOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "partiallyClosePositionViaSignature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "positionIsLiquidatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "tradePair",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "positionId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "removedMargin",
                type: "uint256",
              },
            ],
            internalType: "struct RemoveMarginFromPositionParams",
            name: "params",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "int256",
                name: "minPrice",
                type: "int256",
              },
              {
                internalType: "int256",
                name: "maxPrice",
                type: "int256",
              },
            ],
            internalType: "struct Constraints",
            name: "constraints",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "signatureHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256",
          },
        ],
        internalType: "struct RemoveMarginFromPositionOrder",
        name: "order_",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData_",
        type: "tuple[]",
      },
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature_",
        type: "bytes",
      },
    ],
    name: "removeMarginFromPositionViaSignature",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "sigHashToTradeId",
    outputs: [
      {
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        internalType: "uint96",
        name: "positionId",
        type: "uint96",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair_",
        type: "address",
      },
    ],
    name: "totalVolumeLimitOfTradePair",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "userManager",
    outputs: [
      {
        internalType: "contract IUserManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ITradeManagerOrdersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ITradeManagerOrdersConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ITradeManagerOrders__factory extends ContractFactory {
  constructor(...args: ITradeManagerOrdersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    controller_: PromiseOrValue<string>,
    userManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ITradeManagerOrders> {
    return super.deploy(
      controller_,
      userManager_,
      overrides || {}
    ) as Promise<ITradeManagerOrders>;
  }
  override getDeployTransaction(
    controller_: PromiseOrValue<string>,
    userManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      controller_,
      userManager_,
      overrides || {}
    );
  }
  override attach(address: string): ITradeManagerOrders {
    return super.attach(address) as ITradeManagerOrders;
  }
  override connect(signer: Signer): ITradeManagerOrders__factory {
    return super.connect(signer) as ITradeManagerOrders__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ITradeManagerOrdersInterface {
    return new utils.Interface(_abi) as ITradeManagerOrdersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITradeManagerOrders {
    return new Contract(address, _abi, signerOrProvider) as ITradeManagerOrders;
  }
}
